// DS: IL10.1
import React from 'react';

export interface Props {
  className?: string;
}

export const Success: React.FC<Props> = ({ className }) => {
  return (
    <img
      alt=""
      src="https://st.deviantart.net/eclipse/global/svg/il10-1.svg?1"
      width="140"
      height="140"
      className={className}
    />
  );
};
